import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

Vue.use(Vuex)

const store = new Vuex.Store({
    actions,
    getters,
    mutations,
    state,
    plugins: [createPersistedState({
        key: 'tm-public-evaluation',
        paths: ['ids']
    })]
})

export default store
